// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__eM39m","options":"AnswerScale_options__2qpeu","selected":"AnswerScale_selected__26AIw"};